'use client';
import s from './MetricsBand.module.css';

/*
 * <MetricsBand>
 *
 * Deep-navy rounded band displaying N statistics (value + label).
 *
 * Props:
 *   items     - Array<{ value, label }>
 *   columns   - grid column count (defaults to items.length)
 *   variant   - "default" (centered) | "industry" (left-aligned) | "light" (white card)
 *   embedded  - when true, renders a <div> with no outer section padding
 *   className - extra class on the outer wrapper
 */

export function MetricsBand({
  items,
  className = '',
  containerClassName = '',
  columns,
  variant = 'default',
  embedded = false,
}) {
  const colCount = columns ?? items.length;
  const Tag = embedded ? 'div' : 'section';

  return (
    <Tag
      className={[
        s.band,
        embedded && s.bandEmbedded,
        variant === 'industry' && s.bandIndustry,
        variant === 'light' && s.bandLight,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={`${s.container} ${containerClassName}`.trim()}>
        <div
          className={s.grid}
          data-cols={colCount}
          style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` }}
        >
          {items.map((m, i) => (
            <div key={i} className={s.cell}>
              <div className={s.value}>{m.value}</div>
              <div className={s.label}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </Tag>
  );
}
